<template>
    <div class="wrap wp-admin wp-core-ui">
        <h1 class="wp-heading-inline">{{ (parentTab !== false) ? parentTab.name : currentTab.name}}</h1>
        <a href="" class="page-title-action" v-if="currentTab.add_new">{{stEditorStrings.add_new}}</a>
        <hr class="wp-header-end">
        <ul class="subsubsub" v-show="parentTab !== false">
            <li v-for="(category, categoryPath, index ) in parentTab.categories">
                <router-link :to="'/' + parentTranslationType + '/' + categoryPath + '/'"
                             :class="{'nav-tab-active': categoryPath === translationType }">
                    {{category.name}}
                    <!--                    <span class="count">(1)</span>-->
                </router-link>
                <span v-show="index !== Object.keys(parentTab.categories).length - 1">|</span>
            </li>
        </ul>


        <div class="tablenav top trp-filters-container">
            <div class="trp-translation-status-container trp-filters-container-item">

                <span class="trp-filter" id="trp-filter-translation-status">
                    <span class="trp-filter-name-translation-status">
                        <strong>{{stEditorStrings.translation_status}}:</strong>
                    </span>
                    <label :for="'trp-filter-translation-status-' + status_key" class="trp-translation-status-checkbox"
                           v-for="(status, status_key) in translationStatusFilters.translation_status">
                        <input type="checkbox" :id="'trp-filter-translation-status-' + status_key"
                               v-model="filterValues[status_key]">
                        {{status}}
                    </label>
                </span>

                <span class="trp-filter">
                    <select name="trp-language" id="trp-filter-language" class="trp-filter-select" :title="stEditorStrings.filter_by_language_tooltip"
                            v-model="filterValues['language']">
                        <option value="trp_default">{{stEditorStrings.filter_by_language}}</option>
                        <option v-for="language in settings['translation-languages']"
                                v-show="currentTab['show_original_language'] || language !== settings['default-language']"
                                :value="language">
                            {{languageNames[language]}}
                        </option>
                    </select>
                </span>

                <span class="trp-filter" v-for="(filter, filter_key) in currentTab.filters">
                    <select :name="filter_key" :id="'trp-filter-' + filter_key " class="trp-filter-select" :title="filter.trp_default"
                            v-model="filterValues[filter_key]">
                        <option v-for="(option, option_key ) in filter" :selected="option_key === 'trp_default'"
                                :value="option_key">
                            {{option}}
                        </option>
                    </select>
                </span>

                <input id="trp-filter-button" type="submit" class="button" :title="stEditorStrings.filter_tooltip"
                       :value="stEditorStrings.filter"
                       @click="filter()"
                >
            </div>

            <div class="search-box trp-filters-container-item">
                <label class="screen-reader-text" for="post-search-input">{{currentTab['search_name']}}</label>
                <input type="search" id="post-search-input" name="s" v-model="filterValues['s']" @keyup.enter="filter">
                <input type="submit" id="search-submit" class="button" :value="currentTab['search_name']"
                       @click="filter" :title="stEditorStrings.search_tooltip">
            </div>
        </div>

        <div class="tablenav top trp-table-actions">
            <bulk-actions
                    :stEditorStrings="stEditorStrings"
                    :defaultActions="defaultActions"
                    :tableControls="tableControls"
                    :currentTab="currentTab"
                    :ajaxUrl="ajaxUrl"
                    :listenForEvents="true"
            >
            </bulk-actions>
            <pagination v-model.lazy.number="currentPage"
                        :stEditorStrings="stEditorStrings"
                        :totalItems="totalItems"
                        :totalNumberOfPages="totalNumberOfPages"
                        :wrongPageValue="wrongPageValue">
            </pagination>

            <br class="clear">
        </div>

        <strings-table
                v-model="tableControls"
                :dictionary="dictionary"
                :currentTab="currentTab"
                :settings="settings"
                :languageNames="languageNames"
                :translationStatusFilters="translationStatusFilters"
                :defaultActions="defaultActions"
                :flagsPath="flagsPath"
                :stEditorStrings="stEditorStrings"
                :currentLanguage="currentLanguage"
                :config="config"
        >
        </strings-table>
        <div class="tablenav top trp-table-actions">
            <bulk-actions
                    :stEditorStrings="stEditorStrings"
                    :defaultActions="defaultActions"
                    :tableControls="tableControls"
                    :currentTab="currentTab"
                    :ajaxUrl="ajaxUrl"
                    :listenForEvents="false"
            >
            </bulk-actions>
            <pagination v-model.lazy.number="currentPage"
                        :stEditorStrings="stEditorStrings"
                        :totalItems="totalItems"
                        :totalNumberOfPages="totalNumberOfPages"
                        :wrongPageValue="wrongPageValue">
            </pagination>
        </div>
        <div class="trp-string-translation-end">

        </div>
    </div>
</template>

<script>
    import axios        from "axios"
    import StringsTable from "./strings-table"
    import Pagination   from "./pagination"
    import BulkActions  from "./bulk-actions"

    export default {
        name       : "TranslationTab",
        components : { BulkActions, Pagination, StringsTable },
        props      : [
            'translationType',
            'parentTranslationType',
            'currentTab',
            'parentTab',
            'dictionary',
            'totalItems'
        ],
        data() {
            return {
                // trp_string_translation_data
                stEditorStrings          : trp_string_translation_data.st_editor_strings,
                defaultActions           : trp_string_translation_data.default_actions,
                translationStatusFilters : trp_string_translation_data.translation_status_filters,
                config                   : trp_string_translation_data.config,
                // trp_editor_data
                settings                 : trp_editor_data.trp_settings,
                languageNames            : trp_editor_data.language_names,
                ajaxUrl                  : trp_editor_data.ajax_url,
                flagsPath                : trp_editor_data.flags_path,
                // data
                currentQuery             : this.$route.query,
                presentationData         : [],
                filterValues             : {},
                currentPage              : 1,
                wrongPageValue           : false,
                currentLanguage          : 'trp_default',
                tableControls            : { checkedStrings : [], selectAllOrVisible : '' }
            }
        },
        watch      : {
            dictionary  : function () {

            },
            currentPage : function ( newPage, oldPage ) {
                if ( newPage !== oldPage ){
                    let page = this.validatePage( newPage )
                    if ( page === null ){
                        this.wrongPageValue = true
                    } else {
                        this.wrongPageValue = false

                        // CurrentPage is modified based on queryurl. Make sure we are not detecting that change.
                        if ( this.$route.query[ 'page' ] != page ){
                            // deep copy is needed because Vue seems to not refresh the variable when adding page
                            let query       = Object.assign( {}, this.$route.query )
                            query[ 'page' ] = page

                            this.$router.push( { path : this.$router.path, query : query } ).catch( err => {
                                console.log( err )
                            } )
                        }
                    }
                }
            },
            $route( to, from ) {
                this.setFilterValues()
            }
        },
        computed   : {
            totalNumberOfPages : function () {
                if( this.totalItems === null ){
                    return 0
                }else {
                    return Math.ceil( this.totalItems / this.config.items_per_page )
                }
            }
        },
        created() {
            this.setFilterValues()
            this.currentLanguage = this.filterValues[ 'language' ]
        },
        methods    : {
            navigate() {
                // vue throws navigation duplicate error
                // this.$router.push( { path : $this.route.path, query : { plan : 'private' } } ).catch( err => {
                // } )
            },
            filter() {
                let query = this.buildQuery( this.filterValues )
                this.$router.push( { path : this.$router.path, query : query } ).catch( err => {
                } )

                this.currentLanguage = this.filterValues[ 'language' ]

                this.currentPage = 1
            },
            buildQuery( filterValues ) {
                let query = {}

                // translation status needs special treatment transforming filterValues into a single query value
                let statusValue          = null
                let boolAddStatusToQuery = false


                // check if all translation status values are the same (all checked, or all unchecked)
                for ( let status_key in this.translationStatusFilters.translation_status ) {
                    if ( this.translationStatusFilters.translation_status.hasOwnProperty( status_key ) ){
                        if ( statusValue === null ){
                            statusValue = filterValues[ status_key ]
                        }
                        if ( statusValue !== filterValues[ status_key ] ){
                            boolAddStatusToQuery = true
                        }
                    }
                }

                // if translation status are different then include them in the query
                if ( boolAddStatusToQuery ){
                    query = Object.assign( query, this.buildQueryForFilter( this.translationStatusFilters.translation_status, filterValues ) )
                }

                // rest of the filter are added only if different from trp_default
                query = Object.assign( query, this.buildQueryForFilter( this.currentTab.filters, filterValues ) )

                // set query for language
                if ( filterValues[ 'language' ] !== 'trp_default' ){
                    query[ 'language' ] = filterValues[ 'language' ]
                }

                // set query for search term
                if ( filterValues[ 's' ] !== '' ){
                    query[ 's' ] = filterValues[ 's' ]
                }

                // keep sorting parameters from query
                if ( this.$route.query[ 'order' ] && (this.$route.query[ 'order' ] === 'asc' || this.$route.query[ 'order' ] === 'desc') ){
                    query[ 'order' ] = this.$route.query[ 'order' ]
                }
                if ( this.$route.query[ 'orderby' ] && this.currentTab[ 'table_columns' ][ this.$route.query[ 'orderby' ] ] ){
                    query[ 'orderby' ] = this.$route.query[ 'orderby' ]
                }

                return query

            },
            buildQueryForFilter( filter, filterValues ) {
                let returnQuery = {}
                for ( let option_key in filter ) {
                    if ( filter.hasOwnProperty( option_key ) && filterValues[ option_key ] !== 'trp_default' ){
                        returnQuery[ option_key ] = filterValues[ option_key ]
                    }
                }
                return returnQuery
            },

            /*
             * Set binded variables for filters, paging and sorting to either default or query arguments if exists
             */
            setFilterValues() {

                // translation status defaults
                this.filterValues.translation_status = {}
                for ( let status_key in this.translationStatusFilters.translation_status ) {
                    if ( this.translationStatusFilters.translation_status.hasOwnProperty( status_key ) ){

                        if ( typeof this.$route.query[ status_key ] !== 'undefined' ){
                            /* If the url query parameter is written by the user in url then it's a string.
                             * If we programatically set the query then it's a boolean.
                             */
                            this.filterValues[ status_key ] = (!(this.$route.query[ status_key ] === 'false' || this.$route.query[ status_key ] === false))
                        } else {
                            this.filterValues[ status_key ] = true
                        }
                    }
                }

                // language default
                if ( typeof this.$route.query[ 'language' ] !== 'undefined' && this.settings[ 'translation-languages' ].includes( this.$route.query[ 'language' ] ) ){
                    //make sure language from url is correct
                    this.filterValues[ 'language' ] = this.$route.query[ 'language' ]
                } else {
                    this.filterValues[ 'language' ] = 'trp_default'
                }


                // specific filters
                for ( let filter_key in this.currentTab.filters ) {
                    if ( this.currentTab.filters.hasOwnProperty( filter_key ) ){
                        if ( typeof this.$route.query[ filter_key ] !== 'undefined' && typeof this.currentTab.filters[ filter_key ][ this.$route.query[ filter_key ] ] !== 'undefined' ){
                            // make sure the url has correct query argument
                            this.filterValues[ filter_key ] = this.$route.query[ filter_key ]
                        } else {
                            // Set trp_default if exists. Else first value.
                            if ( this.currentTab.filters[ filter_key ][ 'trp_default' ] ){
                                this.filterValues[ filter_key ] = 'trp_default'
                            } else {
                                this.filterValues[ filter_key ] = Object.keys( this.currentTab.filters[ filter_key ] )[ 0 ]
                            }
                        }
                    }
                }

                //search term
                if ( typeof this.$route.query[ 's' ] !== 'undefined' && this.$route.query[ 's' ] !== '' ){
                    //todo maybe do some sanitizing
                    this.filterValues[ 's' ] = this.$route.query[ 's' ]
                } else {
                    this.filterValues[ 's' ] = ''
                }

                //paging
                if ( typeof this.$route.query[ 'page' ] !== 'undefined' && this.validatePage( this.$route.query[ 'page' ] ) !== null ){
                    this.currentPage = this.validatePage( this.$route.query[ 'page' ] )
                } else {
                    this.currentPage = 1
                }

            },
            validatePage( pageNumber ) {
                let parsedPageNumber = parseInt( pageNumber )
                if ( (1 <= parsedPageNumber) && (this.totalItems === null || parsedPageNumber <= this.totalNumberOfPages ) ){
                    return parsedPageNumber
                } else {
                    return null
                }
            }
        }
    }
</script>
